// ia-consent.ts — Consentement RGPD au transfert IA (Anthropic, hors UE).
// Vu dans la popup « Mon compte ». Solo : par utilisateur ; multi : org (DS).
import { req } from './_internals.js';

export const iaConsentApi = {
  getMyIaConsent: () => req('GET', '/me/ia-consent'),
  putMyIaConsent: (consent: boolean) => req('PUT', '/me/ia-consent', { consent }),
};
